import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { ProjectStatus } from '../../models/project';
import { OptionService } from '../option.service';

@Component({
  selector: 'cw-project-status',
  templateUrl: './project-status.component.html',
  styleUrls: ['./project-status.component.scss']
})
export class ProjectStatusComponent implements OnInit {
  @Input() status: ProjectStatus;

  constructor(private optionService: OptionService) {
  }

  ngOnInit() {
  }

  @HostBinding('class') get className() {
    return this.status;
  }

  get name() {
    return this.optionService.projectStatusNames[this.status];
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/project-status/project-status.component.ts